import { writable } from 'svelte/store';
export const store = {
    remoteVideoElement: writable(null),
    peerConnection: writable(null),
    negotiationneededCounter: writable(0),
    remoteVideoStream: writable(null),
    ws: writable(null),
    dataChannel: writable(null),
    isConnected: writable(false),
    connection: writable(null),
    isTabletMode: writable(false),
    windowRect: writable(null),
    videoRegion: writable(null),
    isIOS: writable(false),
    container: writable(null),
    setting: writable(null),
    me: writable(''),
    buffer: writable([]),
    ffmpeg: writable(null),
    editableMovie: writable(null),
    downloadBlob: writable(null),
};
